<template>
  <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">แสดงรายชื่อลูกค้าทั้งหมดของระบบ</h1>
                <p
                    class="text-white pb-0 px-3"
                >แสดงชื่อลูกค้าทั้งหมด เพื่อให้สามารถจัดการลูกค้าได้</p>
            </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <div class="row justify-content-between">
                            <div class="col-12">
                                <h3 class="text-muted">ค้นหา</h3>
                                <div class="col-lg-12">
                                    <b-form-group class="mb-0" >
                                        <div class="row">
                                            <div class="col-lg m-1">
                                                <input
                                                    type="text"
                                                    placeholder="ชื่อ"
                                                    class="form-control"
                                                    v-model="search.name"
                                                />
                                            </div>
                                            <div class="col-lg m-1">
                                                <input
                                                    type="text"
                                                    placeholder="อีเมล์"
                                                    class="form-control"
                                                    v-model="search.email"
                                                />
                                            </div>
                                            <div class="col-lg m-1">
                                                <input
                                                    type="text"
                                                    placeholder="เบอร์โทรศัพท์"
                                                    class="form-control"
                                                    v-model="search.tel"
                                                />
                                            </div>
                                            <div class="col-lg-2 m-1">
                                                <button class="btn btn-info btn-sm-res" @click="getUser()" :disabled="checkErrorBeforeSearch">
                                                <i class="fa fa-search"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </b-form-group>
                                    <hr class="d-md-none d-lg-none" />
                                </div>
                                <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                    <hr class="d-block d-md-none d-lg-none mb-0" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- table -->
                    <div id="tablePrint">
                        <b-table
                            show-empty
                            responsive
                            :items="user"
                            :fields="fields"
                            :per-page="search.perPage"
                            class="scroll-bar-pop text-center"
                            empty-text="ไม่มีข้อมูลผู้ใช้"
                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        >
                            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
                            <template slot="manage" slot-scope="data">
                                <button class="btn btn-sm btn-dark px-3" @click="fakeUser(data.item)">
                                    <i class="fas fa-mask"></i> ปลอมเป็นผู้ใช้
                                </button>
                            </template>
                        </b-table>
                        <div class="mt-3">
                            <b-pagination 
                                :total-rows="totalItem"
                                :current-page="search.page"
                                :per-page="search.perPage"
                                :value="search.page" 
                                @input="changePage"
                                align="right">
                            </b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </div> 
</template>

<script>
const API_URL = process.env.VUE_APP_API;
import validatePop from "../plugins/validatePop.js"
export default {
    name:"fakecustomer",
    data(){
        return {
            busy: false,
            user: [],
            search: {
                errorShopCode: false,
                errorSACode: false,
                page: 1,
                perPage: 20,
                name: "",
                email: "",
                tel: "",
            },
            totalItem: 0,
            responseFake: {
                status: "",
                tmpKey: "",
                customerId: 0,
                phone: ""
            }
        }
    },
    mounted(){
        this.getUser()
    },
    methods:{
        getUser() {
            this.busy = true
            this.$http
                .post(API_URL + "/shippop/customer", {
                   ...this.search
                },
                {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.handleLoader();
                    this.user = res.data.data.data;
                    this.totalItem = res.data.data.totalItem;
                    
                });
        },
        async fakeUser(data) {
            await this.$http
                .post(API_URL + "/shippop/getTokenExpire",{
                customerId: data.id,
                phone: data.tel
            },
            {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }).then(res => {
                this.responseFake = res.data.data
            }).finally(() => {
                window.open(`${process.env.VUE_APP_TRACKING_URL}force/${this.responseFake.tmpKey}`, '_blank');
            })
        },
        handleLoader(){
            this.busy = !this.busy
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.getUser()
        },
        getOverAllIndex(index){
            return ( this.search.page * 20 ) - 20 + index + 1
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "SUCCESS",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ตกลง",
            contentClass: "modal-success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
    },
    computed:{
        checkErrorBeforeSearch(){
           return ( this.search.errorShopCode || this.search.errorSACode ) == false ? false : true
        },
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "name", label: "ชื่อ", sortable: true },
                { key: "email", label: "อีเมล์", sortable: true },
                { key: "tel", label: "เบอร์โทรศัพท์", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>